<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Events
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          
          <template v-slot:item.status="{ item }">
                <v-icon v-if="item.status == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.status == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="edit(item.id)"
            >
              mdi-pencil
            </v-icon>
            <a 
                :href="'/event/'+item.alias" target="_blank">
              <v-icon
                small
                class="mr-2"
                
              >
                mdi-eye
              </v-icon>
            </a>
            <v-icon
            small
            class="mr-2"
            @click="getAttendees(item.id)"
            >
                mdi-view-list
            </v-icon>
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Event</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newevent.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
              <v-container>
                <v-row>
                  
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Basic Information</p>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-switch
                      v-model="newevent.status"
                      label="Active"
                    ></v-switch>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-switch
                      v-model="newevent.is_featured"
                      label="Featured"
                    ></v-switch>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-switch
                      v-model="newevent.require_registration"
                      label="Require Registration"
                    ></v-switch>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-switch
                      v-model="newevent.require_cv"
                      label="Require CV"
                    ></v-switch>
                </v-col>
                  
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.title"
                      label="Title*"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-event"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.event_link"
                      label="Url"
                      prepend-icon="mdi-link"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.event_link_description"
                      label="Link type"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.max_spaces"
                      label="Number of Spaces"
                      prepend-icon="mdi-account-group"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-img :src="newevent.photo_path" height="40" width="40">
                    </v-img>
                    <v-file-input
                        accept="image/*"
                      v-model="newevent.photo"
                      label="Picture"
                      prepend-icon="mdi-camera"
                      clearable
                      
                    ></v-file-input>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newevent.location"
                      :items="['Online','In-person']"
                      label="Location"
                      required
                    ></v-select>
                  </v-col>
                  
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  <p>Description</p>
                  <vue-editor
                      v-model="newevent.description"
                      label="Description"
                    ></vue-editor>
                </v-col>
                 
                  
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  <p>Email Text</p>
                  <vue-editor
                      v-model="newevent.email_text"
                      label="Email Text"
                    ></vue-editor>

                  <v-text-field v-model="test_email" label="Test Email Address"></v-text-field>  
                  <v-btn @click="sendTestEmail" color="primary">Send Test Email</v-btn>
                </v-col>
                 
                  
                </v-row>
                <hr/>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Optional Information</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Address</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newevent.region"
                      label="Region"
                      :items="regions"
                      clearable
                    ></v-select>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.address"
                      label="Address"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>

                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.city"
                      label="City"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.postal_code"
                      label="Postal Code"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Contact Information</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.contact_email"
                      label="Contact Email"
                      clearable
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newevent.contact_phone"
                      label="Contact Phone"
                      clearable
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Other Information</p>
                  </v-col>
                  
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-menu
                      ref="start_date_menu"
                      v-model="start_date_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newevent.start_date"
                          label="Start date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newevent.start_date"
                        min="2018-01-01"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-menu
                      ref="end_date_menu"
                      v-model="end_date_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newevent.end_date"
                          label="End date"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newevent.end_date"
                        min="2018-01-01"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                cols="12" sm="12" md="6">
                    <h5>Start Time</h5>
                    <v-time-picker
                        v-model="newevent.start_time"
                        format="24hr">

                    </v-time-picker>
                </v-col>
                <v-col
                cols="12" sm="12" md="6">
                    <h5>End Time</h5>
                    <v-time-picker
                        v-model="newevent.end_time"
                        format="24hr">

                    </v-time-picker>
                </v-col>
                
                </v-row>
                
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="attendeeDialog">
            <v-card>
                <v-card-title>Attendees
                  <downloadexcel
                    :data="attendees"
                    :fields="attendee_fields">
                    <v-btn large color="primary" class="ml-2">Download <v-icon>mdi-download</v-icon></v-btn>
                  </downloadexcel>
                </v-card-title>
                <v-card-text>

                    <v-data-table
                        :headers="attendeeHeaders"
                        :items="attendees"
                        :items-per-page="itemsPerPage"
                        :loading="loading"
                        class="elevation-1"
                    >
                    <template v-slot:item.name="{ item }">
                      {{ getName(item) }}
                    </template>
                    <template v-slot:item.email="{ item }">
                      {{ getEmail(item) }}
                    </template>
                    <template v-slot:item.attendee_resumes="{ item }">
                      <template v-if="item.user">
                        <div v-for="resume in item.user.resumes" :key="resume.id" class="resume-item">
                          <a :href="getDownloadLink(resume.path)" target="_blank" rel="noopener">
                            {{ resume.original_file_name || 'Unnamed File' }}
                          </a>
                        </div>
                      </template>
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  import { VueEditor } from "vue2-editor";
  
  import downloadexcel  from "vue-json-excel";
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      events: Array,
      organizations:Array,
      categories:Array,
      regions:Array,
      baseurl:String,
    },
    components: {
      Head,
      VueEditor,
      downloadexcel
    },
    layout: Layout,
    data() {
        return {
            start_date_menu: null,
            end_date_menu: null,
            list: [],
            keyword: "",
            location: "",
            total: this.events.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Title', value:'title'},
              { text: 'Active', value:'status'},
              { text: 'Actions', value:'actions'}

            ],
            attendeeHeaders: [
              { text: 'ID', value:'user_id'},
              { text: 'Name', value: 'name'},
              { text: 'Email', value:'email'},
              { text: 'Organization', value:'organization'},
              { text: 'Referral', value:'referral'},
              { text: 'Booking Date', value:'created_at'},
              { text: 'Resumes', value:'attendee_resumes'}

            ],
            attendee_fields: {
            "ID": "user_id",
            "First Name":"user.first_name",
            "Last Name":"user.last_name",
            "Email":"user.email",
            "Name":"name",
            "Email2":"email",
            "Organization":"organization",
            "Referral":"referral",
            "Booking Date":"created_at",
            },
            test_email: "",
            newevent: {
              title:"",//
              alias: "",//
              email_text:"",
              description: "",//
              status: false,
              is_featured:false,
              require_cv: false,
              require_registration: false,
              address: "",//
              city: "",//
              region: "",//
              country: "IE",//
              postal_code: "",//
            
              max_spaces: 0,
              location: "",
              contact_email:"",
              contact_phone:"",
              start_date:"",
              end_date:"",
              start_time:"",
              end_time:"",
              event_link:"",
              photo: [],
              photo_path: "",
              event_link_description: ""

            },
            newtag:"",
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false,
            attendeeDialog: false,
            attendees: [],
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.events));
    },
    methods: {
      getName(item) {
        if (item.user && item.user.first_name) {
          return `${item.user.first_name} ${item.user.last_name}`;
        }
        return item.name || 'N/A';
      },

      getEmail(item) {
        return item.user ? item.user.email : item.email;
      },

    sendTestEmail() {
      let data = { email: this.test_email, text: this.newevent.email_text };
      axios.post("/admin/events/sendTestEmail", data).then((response) => {
        console.log('send test email got response',response.data)
      });
    },
      getDownloadLink(path) {
        return `${this.baseurl}/resumes/${path}`;
      },
      getAttendees(id) {
        this.attendees = [];
        axios.get("/admin/events/getAttendees/"+id).then((response) => {
            this.attendees = response.data
            this.attendeeDialog= true;
        })
      },
      suggestTags() {
        const formData = new FormData()
        Object.keys(this.newevent).forEach(key => formData.append(key, this.newevent[key]));


        axios.post("/admin/events/suggestTags",formData).then((response) => {
            console.log('suggest tags got response',response.data)
            if (response && response.data)
            {
                this.newevent.tags = [...new Set([...this.newevent.tags, ...response.data])]  
            }
        });
      },
      addTag() {
        if (this.newtag)
          this.newevent.tags.push(this.newtag);
      },
      edit(id) {
        this.newevent = {
              title:"",//
              alias: "",//
              email_text:"",
              description: "",//
              status: false,
              is_featured:false,
              require_cv: false,
              require_registration: false,
              address: "",//
              city: "",//
              region: "",//
              country: "IE",//
              postal_code: "",//
            
              max_spaces: 0,
              location: "",
              contact_email:"",
              contact_phone:"",
              start_date:"",
              end_date:"",
              start_time:"",
              end_time:"",
              event_link:"",
              photo: [],
              photo_path: "",
              event_link_description: ""

            }

        console.log('attempting to edit id ',id)
        this.newtag = "";
        axios.get("/admin/events/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newevent = response.data
                if (this.newevent.status)
                  this.newevent.status = true;
                if (this.newevent.is_featured)
                  this.newevent.is_featured = true;
                
                if (this.newevent.require_cv)
                  this.newevent.require_cv = true;

                if (this.newevent.require_registration)
                  this.newevent.require_registration = true;
                if (this.newevent.tag_strings && this.newevent.tag_strings.length)
                {
                  this.newevent.tags = this.newevent.tag_strings
                }
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        Object.keys(this.newevent).forEach(key => {
            if (key == 'photo')
                this.newevent.key = []
            else
                this.newevent[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/events/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      // Turns a failed save into something the editor can act on —
      // Laravel returns the specific field errors in a 422 body.
      saveErrorMessage (error, fallback) {
        const errors = error.response && error.response.status === 422 && error.response.data.errors
        return errors ? Object.values(errors).flat().join('\n') : fallback
      },
      saveEditDialog () {
        this.loadingAdd=true;
        const formData = new FormData()
        Object.keys(this.newevent).forEach(key => formData.append(key, this.newevent[key]));
        axios.post("/admin/events/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch((error) => {
          this.loadingAdd = false;
          alert(this.saveErrorMessage(error, 'Edit failed'));
        });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        console.log('adding event',this.newevent)
        const formData = new FormData()
        Object.keys(this.newevent).forEach(key => formData.append(key, this.newevent[key]));
        axios.post("/admin/events/add",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        }).catch((error) => {
          // Without this, a rejected request (e.g. a 422 validation error)
          // left the dialog open with no message and loadingAdd stuck on,
          // so the save looked like it silently did nothing.
          this.loadingAdd = false;
          alert(this.saveErrorMessage(error, 'Add failed'));
        });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  